/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { Modal } from 'antd-mobile'
import * as _ from 'lodash'
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
import { QuickMessageModal } from '@styles/modal'
import { checkUrl, isCustomProfileImg, makeItemImageUrl, showToast, TOAST_TYPE } from '@utils/utils'
import { MESSAGE_TYPE } from 'adv-protocol/src/GameCommon'
// icon
import { DownloadIco, ItemBoxIco, PickSolidIco, SharedBetIco } from '@shared/Icon/MessageIcon'
// css
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn, SpanButton } from '@styles/button.style'
import { ItemWrapBtnStyle } from '@views/Popup/Message/index.style'
import { IMessageOne, IMessageOneForUser } from '@protocol/message'
import { getErrorText } from '@game/errtext'
import { message } from 'antd'
import { bettingHistoryStore } from '@store/index'
import { MESSAGE_IMAGE_BASE_URL } from '@constants/index'
import { messageReadMoreBtnStyle, QuickMessageWrap } from './index.style'
import { ImageWrap, LinkWrap } from '../MessageContentPopup/index.style'
import { FROM_VIEW_TYPE, GlobalStoreKey } from '@v2/constants/common'
import { showReceiveFailItemsMessage, showReceiveItemErrorMessage } from '@views/Popup/Message/MessageHelper'
import AdvImg from '@components/AdvImg'
import dayjs from 'dayjs'
// img
import AdvProfileImg from '@assets/images/icon/adv-profile.png'
import clubEmblemAlternateImg from '@assets/images/icon/logo-shield-gray-club.png'
import MagnifyingGlassIco from '../../../shared/Icon/EtcIcon/MagnifyingGlassIco'
import PopupUtils from '@utils/popup-utils'
import DialogUtils from '@utils/dialog-utils'

enum QuickMessageMode {
  USER,
  CLUB
}

const QuickMessagePopup: React.FC = () => {
  const {
    userStore,
    clubStore,
    globalStore,
    messageStore,
    pickStore,
    authStore,
    matchupStore,
  } = useRootStore()
  const { visibleQuickMessagePopup } = globalStore
  const { notificationData } = userStore
  const { club } = matchupStore
  const { unQuickReadUserMessage, unReadClubMessage } = messageStore
  const [ clubMessage, setClubMessage] = useState<IMessageOne.Schema>(undefined)
  const [disbabledRecevieItemButton, setDisbabledRecevieItemButton] = useState(false)
  const days = ['일', '월', '화', '수', '목', '금', '토']

  const getDateFormat = (date: string): string => {
    const d = dayjs(date)
    const f = [d.format('MM/DD'), '(', _.nth(days, d.day()), ') ', d.format('HH:mm')]
    return f.join('')
  }

  const applyDefaultEmblem = e => {
    e.target.src = clubEmblemAlternateImg
  }

  const messageInfo: IMessageOneForUser.Schema = {
    id: '',
    title: '',
    content: '',
    attachedUrl: '',
    senderNick: '',
    senderId: '',
    itemCode: 0,
    itemQuantity: 0,
    itemPeriod: 0,
    itemVolume: 0,
    productId: 0,
    receivedItem: 0,
    item: null,
    pickPurchase: null,
    pick: null,
    sharedBettingHistory: null,
    receiverread: 0,
    createdAt: '',
    dateExpire: '',
    messageType: null,
  }

  let mode = QuickMessageMode.USER

  if (clubMessage &&
    _.eq(notificationData.unQuickReadMessageCount, 0)) {
    mode = QuickMessageMode.CLUB
  }

  const isUserMessage = mode === QuickMessageMode.USER
  const isClubMessage = mode === QuickMessageMode.CLUB

  let hasAttachedUrl = false
  let hasItem = false
  let hasPick = false
  let hasSharedBettingHistory = false

  let isPurchasedPick = false

  let itemIcon = ''

  const isItemReceivable = () => {
    return messageInfo.receivedItem === 0
  }

  if (isUserMessage
    && unQuickReadUserMessage) {
    const {
      id,
      title,
      content,
      attachedUrl,
      senderNick,
      senderId,
      createdAt,
      dateExpire,
      messageType,
      senderProfileImg,
    } = unQuickReadUserMessage
    const { itemCode, itemQuantity, itemVolume, item, receivedItem } = unQuickReadUserMessage
    const { pick, pickPurchase, sharedBettingHistory, attachedImage} = unQuickReadUserMessage

    hasAttachedUrl = !_.isEmpty(attachedUrl)
    hasItem = itemCode > 0 && itemQuantity > 0
    hasPick = !_.isEmpty(pick)
    hasSharedBettingHistory = !_.isEmpty(sharedBettingHistory) && globalStore.findGlobalSetting(GlobalStoreKey.BETTING_HISTORY_SHARE_ENABLED)?.value === '1'

    isPurchasedPick = !_.isEmpty(pickPurchase)

    messageInfo.id = id
    messageInfo.title = title
    messageInfo.content = content
    messageInfo.senderNick = senderNick
    messageInfo.senderId = senderId
    messageInfo.createdAt = createdAt
    messageInfo.dateExpire = dateExpire
    messageInfo.messageType = messageType
    messageInfo.senderProfileImg = senderProfileImg

    if (hasAttachedUrl) {
      messageInfo.attachedUrl = attachedUrl
    }

    if (hasItem) {
      messageInfo.itemCode = itemCode
      messageInfo.itemQuantity = itemQuantity
      messageInfo.itemVolume = itemVolume
      messageInfo.item = item
      messageInfo.receivedItem = receivedItem

      itemIcon = makeItemImageUrl(item)
    }

    if (hasPick) {
      messageInfo.pick = pick
      messageInfo.pickPurchase = pickPurchase
    }

    if (hasSharedBettingHistory) {
      messageInfo.sharedBettingHistory = sharedBettingHistory
    }

    messageInfo.attachedImage = attachedImage
  }

  if (isClubMessage
    && unReadClubMessage) {
    const { id, title, content, clubName, createdAt, dateExpire, senderProfileImg, messageType } = unReadClubMessage
    messageInfo.id = id
    messageInfo.title = title
    messageInfo.content = content
    messageInfo.senderNick = clubName
    messageInfo.createdAt = createdAt
    messageInfo.dateExpire = dateExpire
    messageInfo.senderProfileImg = senderProfileImg
    messageInfo.messageType = messageType
  }

  const isDoNotSellPick = (sell: number) => {
    return sell === 0
  }

  const isExpiredPick = (betEnd) => {
    const now = new Date()
    return betEnd <= now
  }

  const isSystemMessage = () => {
    return messageInfo.messageType === MESSAGE_TYPE.SYSTEM
      || messageInfo.messageType === MESSAGE_TYPE.REWARD
      || (messageInfo.messageType === MESSAGE_TYPE.NORMAL && _.isEmpty(messageInfo.senderId))
  }

  const makeReceiveItemMessage = (row: IMessageOneForUser.Schema): string => {
    if (row.item.volume_object === 1) {
      return `${row.item.name} x${row.itemVolume}을(를) 획득 하였습니다.`
    }
    return `${row.item.name}을(를) 획득 하였습니다.`
  }

  const onReadMessage = async () => {
    const { readMessage, quickReadMessage } = messageStore

    if (isUserMessage) {
      const params = {
        messageId: unQuickReadUserMessage.id,
      }

      await quickReadMessage(params)
      userStore.decreaseUnQuickReadMessageCount()
    }

    if (isClubMessage) {
      const clubId = club.id
      const params = {
        messageId: messageInfo.id,
        clubId,
      }

      await readMessage(params)
      await clubStore.fetchUnReadClubMessageCount(clubId)
      await messageStore.getOneUnReadMessageByClubId({ clubId })
    }
  }

  const onReceiveItem = async () => {
    const { id, itemCode } = messageInfo

    if (itemCode > 0 && isItemReceivable()) {
      const { receiveFailMessageDetail, errcode } = await messageStore.receiveMessage({
        messageId: id,
        isMessageRead: false,
      })
      const { failItems } = receiveFailMessageDetail
      if (!_.isEmpty(failItems)) {
        showReceiveFailItemsMessage(failItems)
      } else if (errcode) {
        showReceiveItemErrorMessage(errcode)
      } else {
        message.info(makeReceiveItemMessage(messageInfo))
        await authStore.refreshSimpleUserInfo(true)
        messageInfo.receivedItem = 1
        messageStore.setUnQuickReadUserMessage(messageInfo)
      }
    }

    setDisbabledRecevieItemButton(false)
  }

  const doCloseMessage = async () => {
    globalStore.setVisibleQuickMessagePopup(false)
    onReadMessage()
  }

  const onClickOpenUrl = () => {
    const { attachedUrl } = messageInfo

    if (!checkUrl(attachedUrl)) {
      showToast(TOAST_TYPE.INFO, '올바른 URL 링크가 아닙니다.')
      return
    }

    globalStore.toMoveWebHomePage(attachedUrl, 'popup')
  }

  const onClickReceiveItem = () => {
    setDisbabledRecevieItemButton(true)
    onReceiveItem()
  }

  const fetch = async () => {
    pickStore.setFetchPickList(null)
    await messageStore.getOneUnQuickReadMessageByUserId()
    await onReadMessage()
  }

  const onShowPickModal = () => {
    const { pick, pickPurchase } = messageInfo

    if (pickPurchase) {
      showToast(TOAST_TYPE.INFO, '이미 구매한 픽 입니다.')
      return
    }

    pickStore.setFetchPickList(fetch)
    pickStore.setPurchasePick(pick, true)
  }

  const onClickPickInfo = () => {
    const { pick } = messageInfo

    if (!pick
      || isDoNotSellPick(pick.sell)
      || isExpiredPick(pick.dateBettingEnd)) {
      showToast(TOAST_TYPE.INFO, '베팅이 마감되거나 공유가 중지된 픽은 구매할 수 없습니다.')
      return
    }

    onShowPickModal()
  }

  const onClickOpenMessage = () => {
    PopupUtils.showMessagePopup()
    doCloseMessage()
  }

  const onClickSaveSharedBettingHistory = async () => {
    try {
      const result = await bettingHistoryStore.saveBettingHistory(
        messageInfo.id, messageInfo.sharedBettingHistory.betId, messageInfo.senderId
      )
      if (result?.errcode) {
        const errcode = result.errcode
        const errText = getErrorText(errcode) || '서버 연결이 원활하지 않습니다. 새로고침해 주세요.'
        showToast(TOAST_TYPE.INFO, errText)
      } else {
        showSaveBettingHistoryCompletePopup()
      }
    } catch (err) {
      console.dir(err)
      message.info('베팅 내역 저장 중 에러가 발생했습니다.')
    }
  }

  const showSaveBettingHistoryCompletePopup = () => {
    DialogUtils.showSaveBettingHistoryComplete({ fromViewType: FROM_VIEW_TYPE.QUICK_MESSAGE, onClose: doCloseMessage })
  }

  const onClickDetailSharedBettingHistory = () => {
    PopupUtils.showMessagePopup()
    doCloseMessage()
  }

  const renderContent = () => {
    let messageContent = messageInfo.content
    if (hasPick) {
      messageContent = '내용이 없습니다.'
    } else if (hasSharedBettingHistory) {
      messageContent = '베팅 내역 공유 메시지 입니다.'
    }
    return (
      <div dangerouslySetInnerHTML={{ __html: messageContent }} className="message-contents"/>
    )
  }

  const onClickViewImg = () => {
    const imageSrc = `${MESSAGE_IMAGE_BASE_URL}${messageInfo.attachedImage}`
    PopupUtils.showAttachedImagePopup({
      imageSrc,
      imageAlt: '퀵메세지 첨부 이미지',
    })
  }

  const renderImg = (
    <ImageWrap className={isSystemMessage() && 'system-message'}>
      <Button TP className="img-wrapper" onClick={() => onClickViewImg()}>
        <AdvImg src={`${MESSAGE_IMAGE_BASE_URL}${messageInfo.attachedImage}`}
                srcMode={isSystemMessage() ? null : 'small'} alt="업로드된 이미지"/>
        <div className="zoom-ico">
          <MagnifyingGlassIco/>
        </div>
      </Button>
    </ImageWrap>
  )

  const renderAttachedUrl = (
    <LinkWrap>
      <SpanButton onClick={onClickOpenUrl} className="attached-link">
        {messageInfo.attachedUrl}
      </SpanButton>
    </LinkWrap>
  )

  const className = []
  if (messageInfo.receivedItem === 1) {
    className.push('received')
  }

  const renderItem = (
    <div className="attached-wrap item">
      <Button disabled={disbabledRecevieItemButton} onClick={onClickReceiveItem} css={ItemWrapBtnStyle}
              className="quick-message">
        <div className={`attached-item ${className.join(' ')}`}>
          <ItemBoxIco isGray={true}/>
          {
            (isItemReceivable()) && (
              <Fragment>
                <span className="item-img">
                  <img src={itemIcon} alt="첨부된 아이템" className="item-img"/>
                </span>
                <span className="download-icon"><DownloadIco/></span>
              </Fragment>
            )
          }
        </div>
      </Button>
    </div>
  )

  const renderPick = (
    <div className="attached-wrap pick">
      <Button onClick={onClickPickInfo} css={ItemWrapBtnStyle} className="quick-message">
        <div className={`attached-item ${className.join(' ')}`}>
          <ItemBoxIco isGray={true}/>
          {
            (!isPurchasedPick) && (
              <Fragment>
                <span className="item-img pick-item">
                  <PickSolidIco/>
                </span>
                <span className="download-icon"><DownloadIco/></span>
              </Fragment>
            )
          }
        </div>
      </Button>
      <Button TP onClick={onClickOpenMessage} css={messageReadMoreBtnStyle}>
        자세히 보러가기
      </Button>
    </div>
  )

  const renderSharedBettingHistory = (
    <div className="attached-wrap pick">
      <Button onClick={onClickSaveSharedBettingHistory} css={ItemWrapBtnStyle} className="quick-message">
        <div className={`attached-item ${className.join(' ')}`}>
          <ItemBoxIco isGray={true}/>
          {
            (!isPurchasedPick) && (
              <Fragment>
                <span className="item-img">
                  <SharedBetIco/>
                </span>
                <span className="download-icon"><DownloadIco/></span>
              </Fragment>
            )
          }
        </div>
      </Button>
    </div>
  )


  useEffect(() => {
    if (unReadClubMessage) {
      setClubMessage(unReadClubMessage)
    }
  }, [visibleQuickMessagePopup])

  let quickMessageClassName = 'quick-message'

  if (hasSharedBettingHistory) {
    quickMessageClassName += ' is-betting-history'
    if (hasAttachedUrl) {
      quickMessageClassName += ' is-attached-url'
    }
  }

  return (
    <Modal
      transparent
      maskClosable={false}
      css={QuickMessageModal}
      className={quickMessageClassName}
      // visible
      visible={visibleQuickMessagePopup}
      onClose={doCloseMessage}
    >
      <QuickMessageWrap>
        <h3 className="sender-wrap">
          <div className="sender-profile">
            {/* 시스템 메시지 */
              isSystemMessage() && (
                <img src={AdvProfileImg} alt="승부사온라인 프로필" className="sender-profile--img system"/>)
            }
            {/* 클럽 엠블럼 이미지 */
              (!isSystemMessage() && isClubMessage) &&
              (<img src={messageInfo.senderProfileImg} onError={applyDefaultEmblem} alt="클럽 엠블렘"
                    className="sender-profile--img"/>)
            }
            {/* 일반 유저 메시지 */
              (!isSystemMessage() && !isClubMessage)
              && ((isCustomProfileImg(messageInfo.senderProfileImg)) ?
                  (<AdvImg src={messageInfo.senderProfileImg} srcMode={'small'} alt="유저 프로필"
                           className="sender-profile--img custom-img"/>) :
                  (<AdvImg src={messageInfo.senderProfileImg} srcMode={'small'} alt="기본 스킨"
                           className="sender-profile--img"/>)
              )
            }
          </div>
          <div className="message-info">
            <p className="sender-info">
              <span className="sender">
                {messageInfo.senderNick}
              </span>
              <p className="date">
                {getDateFormat(messageInfo.createdAt)}
                <span className="term">
                  {dayjs(messageInfo.dateExpire).diff(dayjs(), 'days')}일 뒤 삭제
                </span>
              </p>
            </p>
            {(hasItem || hasPick || hasSharedBettingHistory) &&
              <div className="message-item">
              {/* ********** 첨부된 아이템이 있는 경우 호출 *********** */}
                {hasItem && renderItem}

                {/* ********** 첨부된 픽 있는 경우 호출 *********** */}
                {hasPick && renderPick}

                {/* ********** 공유된 베팅내역 있는 경우 호출 *********** */}
                {hasSharedBettingHistory && renderSharedBettingHistory}
              </div>
            }
          </div>

        </h3>

        {renderContent()}

        {/* ********** 첨부된 이미지가 있는 경우 호출 *********** */}
        {!_.isEmpty(_.trim(messageInfo.attachedImage)) && renderImg}

        {/* Url 이 첨부되어 있을 경우 */}
        {hasAttachedUrl && renderAttachedUrl}

        {/* ********** 공유된 베팅내역 있는 경우 호출 *********** */}
        {hasSharedBettingHistory &&
          <Button TP onClick={onClickDetailSharedBettingHistory} css={messageReadMoreBtnStyle} className={hasAttachedUrl && 'is-attached-url'}>
            자세히 보러가기
          </Button>
        }

      </QuickMessageWrap>

      <Button
        circle
        onClick={doCloseMessage}
        css={CloseBtn}
        className="close-btn modal-circle-close-btn modal-bottom-btn">
        <span className="close-txt">닫기</span>
      </Button>

      <ModalBg onClick={doCloseMessage}/>
    </Modal>
  )
}
export default observer(QuickMessagePopup)
